'use client';

import type { ButtonProps } from '@mui/material/Button';

import { useTranslations } from 'next-intl';

import Button from '@mui/material/Button';

export function SignInButton({ sx, ...other }: ButtonProps) {
  const t = useTranslations('Auth');

  return (
    <Button
      component="a"
      href="/auth/login/?returnTo=/dashboard"
      variant="contained"
      sx={sx}
      {...other}
    >
      {t('login')}
    </Button>
  );
}
